import { getTextColor } from '../HelperMethods'
import * as sRGB from 'vuetify/src/util/color/transformSRGB'
import * as LAB from 'vuetify/src/util/color/transformCIELAB'
import { colorToInt, intToHex } from 'vuetify/src/util/colorUtils'
import MaterialColors from 'vuetify/es5/util/colors'

const Colors = {
  data () {
    return {}
  },
  methods: {
    getTextColor (value) {
      return getTextColor(value)
    },
    lightenColor (value, amount) {
      const lab = LAB.fromXYZ(sRGB.toXYZ(colorToInt(value)))
      lab[0] = lab[0] + amount * 10
      return intToHex(sRGB.fromXYZ(LAB.toXYZ(lab)))
    },
    darkenColor (value, amount) {
      const lab = LAB.fromXYZ(sRGB.toXYZ(colorToInt(value)))
      lab[0] = lab[0] - amount * 10
      return intToHex(sRGB.fromXYZ(LAB.toXYZ(lab)))
    }
  },
  computed: {
    materialColors () {
      return MaterialColors
    },
    ratingColorMap () {
      return {
        H: this.materialColors.green.base,
        G: this.materialColors.lightBlue.base,
        P: this.materialColors.purple.lighten2,
        L: this.materialColors.orange.base,
        V: this.materialColors.red.base,
        N: this.materialColors.grey.base
      }
    },
    chartColors () {
      return [
        this.materialColors.red.base,
        this.materialColors.blue.base,
        this.materialColors.yellow.base,
        this.materialColors.green.base,
        this.materialColors.orange.base,
        this.materialColors.purple.base,
        this.materialColors.indigo.base,
        this.materialColors.lightBlue.base,
        this.materialColors.brown.base,
        this.materialColors.grey.base,
        this.materialColors.lightGreen.base,
        this.materialColors.amber.base,
        this.materialColors.blueGrey.base,
        this.materialColors.deepOrange.base
      ]
    },
    logicColours () {
      return [
        this.materialColors.red.base,
        this.materialColors.blue.base,
        this.materialColors.green.base,
        this.materialColors.orange.base,
        this.materialColors.purple.base,
        this.materialColors.brown.base,
        this.materialColors.grey.base,
        this.materialColors.indigo.base,
        this.materialColors.lightBlue.base,
        this.materialColors.amber.base,
        this.materialColors.blueGrey.base,
        this.materialColors.deepOrange.base
      ]
    }
  }
}

export default Colors



// WEBPACK FOOTER //
// ./src/mixins/Colors.js